//package imports 
import React, { useEffect, useState } from "react";

//componenet imports
import CustomTable from "../../utils/resuableComponents/CustomTable";
import {getMasterData,getHomeData} from "../../services/apiServices/GetServices";
import { callDynamicValueEdit,callHomeDataEdit } from "../../services/apiServices/PostServices";
import MetaDataEditModal from "../../utils/resuableComponents/MetaDataEditModal";
import { mastercontactList,dynamicChangesHeader,timeLineHeader,masterHomeData} from "../../utils/constants/TableHeader";
import { showToast } from "../../utils/constants/Toaster";
import { homeAdditionalServiceText } from "../../utils/TextInputUtils";
import Loader from "../loadingScreens/Loader";


const MasterData = (props) => {
    const [modalData,setModalData]=useState([])
    const [simpleModal, setSimpleModal] = useState(false)
    const [enquireListToggle,setEnquireListToggle]=useState(2);
    const [contactlistData,setContactListData]=useState([])
    const [dynamicData,setDynamicData]=useState([])
    const [timeLineData,setTimeLineData]=useState([])
    const [tableData,setTableData]=useState([])
    const [masterData,setMasterData]=useState([])
    const [fromData,setFromData]=useState("dynamicData")
    const [isLoader,setIsLoader]=useState(false)
    const [homeServices,setHomeServices]=useState([])
  
    const pathName = undefined
    
   const homeData = [
    {
    description: "Ideation of Osan Grows to offer Franchise & Share distribution to help budding entrepreneurs.",
    id: "U2FsdGVkX18XXRLvX4q0n4a8SAjtipnF9suSOSCb78g=",
    store_name:"Osan Mart",
    expected_reach :"400-500"
    },
    {
    description: "Ideation of Osan Grows to offer Franchise & Share distribution to help budding entrepreneurs.",
    id: "U2FsdGVkX18XXRLvX4q0n4a8SAjtipnF9suSOSCb7845=",
    store_name:"Osan Phamarcy",
     expected_reach :"50-100"
    },
    ]

    useEffect(() => {
            getMasterDataDetails()
            getHomeServiceDetails()
    }, []);

    useEffect(() => {
        if(enquireListToggle === 2 ){
            setTableData(dynamicData)
        }else if(enquireListToggle ==3){
            setTableData(timeLineData)
        }else{
            setTableData(contactlistData)
        }
    }, [masterData]);

     //function to handle tab
     const handleTabHomeData = () => {
        setEnquireListToggle(1)
        setTableData(contactlistData)
        setFromData("homeData")
      } 
      
      //function to handle tab onclick
      const handleTabDynamicChanges = () => {
        setEnquireListToggle(2)
        setTableData(dynamicData)
        setFromData("dynamicData")  
        } 

        //function to handle tab onclick
      const handleTabTimeLine = () => {
        setEnquireListToggle(3)
        setTableData(timeLineData) 
        setFromData("timeLine")       
        } 
   

    //function call to get masterData  data
    const getMasterDataDetails = async () => {
        setIsLoader(true)
        try{
            const res = await getMasterData("master_data");
            if (res.success) {
                setDynamicData(res?.dynamic_changes)
                setContactListData(res?.contact_us)
                setTimeLineData(res?.time_line)
                setMasterData(res)
                setEnquireListToggle(enquireListToggle)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    //function call to get masterData  data
    const getHomeServiceDetails = async () => {
        setIsLoader(true)
        try{
            const res = await getHomeData("homeData");
            if (res.success) {
                setHomeServices(res?.home_data)
                setEnquireListToggle(enquireListToggle)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    //function to open edit modal
    const handleEditOpen = (data) => {
        setModalData(data)
        setSimpleModal(true)
    }
     //function to close modal 
     const closeEditModal = () => {
       setSimpleModal(false)
    }

    //function call to api edit dynamic api
    const callDynamicApi = async (body) => {
        try{
            const res = await callDynamicValueEdit("master_data",body) 
            if(res?.success){
             showToast(1,res?.message)
             setTableData(dynamicData)
             setSimpleModal(false)
             getMasterDataDetails()
             
            }else{
             console.log("res",res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    // function call to call  edit timeLine api
    const callTimeLineApi = async (body) => {
        try{
            const res = await callDynamicValueEdit("time_line",body) 
            if(res?.success){
             showToast(1,res?.message)
             setTableData(timeLineData)
             setSimpleModal(false)
              getMasterDataDetails()
            }else{
             console.log("res",res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    const callHomeServicesApi = async (body) => {
        try{
            const res = await callHomeDataEdit("homeData",body)
            if(res?.success){
             showToast(1,res?.message)
             setSimpleModal(false)
             getHomeServiceDetails()
            }else{
             console.log("res",res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }
    //function to call edit api 
    const handleUpdateActon = async (reqbody) => {
       
        if(enquireListToggle === 2){
            callDynamicApi(reqbody)
        }else if(enquireListToggle === 3){
            callTimeLineApi(reqbody)
        }else if (enquireListToggle === 1){
            callHomeServicesApi(reqbody)
        }
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null}
        <div class="d-flex w-50 flex-row  align-items-center w-100 border-bottom p-2">
            <h1 class="fs-4 ms-3 Montserrat fw-semi-bold">
            Master Data   
            </h1>
        </div>
        <hr class="hr w-100 m-0" />
        <div class="d-flex ">
        <div class="d-flex  w-75">
        <div class={enquireListToggle === 2 ? " roboto align-self-end tabBorder pointer me-2 ms-4 h-50 my-2" :" align-self-end roboto pointer me-2 ms-4 h-50 my-2"} onClick={handleTabDynamicChanges} >
                <h5 class={enquireListToggle === 2 ?"fw-bold m-0 " : "status-pending m-0"}>Dynamic Changes</h5>
             </div>
             <div class={enquireListToggle === 3 ? "mx-4 align-self-end roboto tabBorder pointer h-50 my-2" :"mx-4 align-self-end roboto pointer h-50 my-2"} onClick={handleTabTimeLine} >
                <h5 class={enquireListToggle === 3 ?"fw-bold m-0" : "status-pending m-0"}>Time Line</h5>
             </div>
             <div class={enquireListToggle === 1 ? "mx-4 align-self-end roboto tabBorder pointer h-50 my-2" :"mx-4 align-self-end roboto pointer h-50 my-2"} onClick={handleTabHomeData} >
                <h5 class={enquireListToggle === 1 ?"fw-bold m-0" : "status-pending m-0"}>Home Franchise Investment</h5>
             </div>
             </div>
             <div class="my-4 pb-1">
                 {""}
             </div>
        </div>
        <MetaDataEditModal open={simpleModal}  close={closeEditModal} from={fromData} data={modalData} edit={"true"}  onClickUpdate={handleUpdateActon} />
        {
            enquireListToggle ===1  ?
            
            <>
            {
                homeServices.map((item,index) => {
                    return(
                        <div key={index} className="my-1">
                           <h6 className="me-2 ms-4 fs-5 text-center fw-bold">{item?.type === 3 ? homeAdditionalServiceText : item?.type_name}</h6>
                        <CustomTable  data={enquireListToggle ===1 ? item?.data :tableData} columnHeader={enquireListToggle === 1 ? masterHomeData : enquireListToggle ===2 ? dynamicChangesHeader :timeLineHeader} onClickAction ={handleEditOpen} from ={"homeData"}  />
                     </div>
                    )
                   
                })
            }
            </> 
             :

             <CustomTable  data={enquireListToggle ===1 ? homeData :tableData} columnHeader={enquireListToggle === 1 ? masterHomeData : enquireListToggle ===2 ? dynamicChangesHeader :timeLineHeader} onClickAction ={handleEditOpen} from ={"Master data"}  />
            
        }
        

        
        
    </div>
    )
}

export default MasterData